import './assets/styles/main.scss'
import {Homepage} from "./layout/Homepage";
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import {PrivacyPolicyPage} from "./layout/PrivacyPolicy";
import {TermsOfServicePage} from "./layout/TermsOfService";
import {ContactPage} from "./layout/Contact";
import withLayout from "./layout/Layout";

function App() {
    return (
        <Router>
                <Routes>
                    <Route path="/" element={withLayout(Homepage)}/>
                    <Route path="/privacy-policy" element={withLayout(PrivacyPolicyPage)}/>
                    <Route path="/terms-of-service" element={withLayout(TermsOfServicePage)}/>
                    <Route path="/contact" element={withLayout(ContactPage)}/>
                    <Route path="*" element={withLayout(Homepage)}/>
                </Routes>
        </Router>
    )
}

export default App
